export default __webpack_public_path__ + "static/media/winston-barrier.c9a2a1b8.mp3";